/** Title-case labels from API snake_case values. */
export function formatSettingsLabel(value) {
  const text = String(value || "")
    .replace(/_/g, " ")
    .trim();
  if (!text) return "";
  return text.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatSubscriptionTier(tier) {
  const formatted = formatSettingsLabel(tier);
  return formatted || "No plan";
}

export function formatSubscriptionCycle(cycle) {
  const formatted = formatSettingsLabel(cycle);
  return formatted || "Not set";
}

export function formatRoleLabel(role) {
  return formatSettingsLabel(role || "user") || "User";
}

export function formatSettingsDate(dateValue) {
  if (!dateValue) return "Not set";
  const ts = Date.parse(String(dateValue).replace(" ", "T"));
  if (Number.isNaN(ts)) return String(dateValue);
  return new Date(ts).toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getSubscriptionStatus(user) {
  const expires = user?.subscription_expires_at;
  if (!expires) {
    return { label: "Active", color: "success" };
  }
  const ts = Date.parse(String(expires).replace(" ", "T"));
  if (Number.isNaN(ts)) {
    return { label: "Active", color: "success" };
  }
  if (ts > Date.now()) {
    return { label: "Active", color: "success" };
  }
  return { label: "Expired", color: "warning" };
}
